var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUniversityLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 32V22.7H15.7V31.2852L23.9783 34.9644C24.0477 34.9786 24.1523 34.9786 24.2217 34.9644L32.5 31.2852V22.8H34.7V32C34.7 32.4347 34.444 32.8287 34.0468 33.0052L25.0468 37.0052C25.0144 37.0196 24.9814 37.0324 24.9479 37.0436C24.4221 37.2188 23.7779 37.2188 23.2521 37.0436C23.2186 37.0324 23.1856 37.0196 23.1532 37.0052L14.1532 33.0052C13.756 32.8287 13.5 32.4347 13.5 32Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9776 13.2358L10.2447 19.3061C10.2327 19.3114 10.2206 19.3165 10.2085 19.3213C10.1872 19.3299 10.1764 19.3377 10.1718 19.3415C10.167 19.3455 10.1641 19.349 10.1618 19.3526C10.1566 19.3606 10.15 19.3769 10.15 19.4C10.15 19.4232 10.1566 19.4394 10.1618 19.4474C10.1641 19.451 10.167 19.4546 10.1718 19.4585C10.1764 19.4623 10.1872 19.4702 10.2085 19.4787C10.2227 19.4844 10.2368 19.4904 10.2507 19.4966L23.9757 25.6629C23.9778 25.6633 23.9798 25.6636 23.982 25.6638C23.9967 25.6657 24.0098 25.666 24.0198 25.6654C24.0632 25.6385 24.1085 25.6146 24.1552 25.5939L37.9552 19.4939C37.9672 19.4886 37.9793 19.4836 37.9914 19.4787C38.0127 19.4702 38.0235 19.4623 38.0281 19.4585C38.0329 19.4546 38.0358 19.451 38.0381 19.4474C38.0433 19.4394 38.05 19.4232 38.05 19.4C38.05 19.3769 38.0433 19.3606 38.0381 19.3526C38.0358 19.349 38.0329 19.3455 38.0281 19.3415C38.0235 19.3377 38.0127 19.3299 37.9914 19.3213C37.9793 19.3165 37.9672 19.3114 37.9552 19.3061L24.2223 13.2358C24.1528 13.2214 24.0471 13.2214 23.9776 13.2358ZM23.2521 11.1565C23.7779 10.9812 24.422 10.9812 24.9478 11.1565C24.9807 11.1674 25.013 11.1799 25.0447 11.1939L38.8292 17.2871C40.7235 18.0642 40.7235 20.7359 38.8292 21.5129L25.1146 27.5752C24.4754 27.952 23.7475 27.9087 23.2521 27.7436C23.2171 27.7319 23.1828 27.7185 23.1492 27.7034L9.36716 21.5115C7.47638 20.7326 7.47755 18.0637 9.37067 17.2871L23.1552 11.1939C23.1869 11.1799 23.2192 11.1674 23.2521 11.1565Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 31.4V19.4H40.2V31.4H38Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2,
    height: 26.2,
    fill: "white",
    transform: "translate(8 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUniversityLight);
export default __webpack_public_path__ + "static/media/icon_university_light.6f567e09.svg";
export { ForwardRef as ReactComponent };